<template>
    <v-card class="p-3 flex-fill col-6 h-100 w-100">
        <div class="d-flex justify-content-between">
            <h5>Tags</h5>

            <div class="d-flex justify-content-between gap-10">
                <router-link to="/configuration/tags">
                    <v-btn outlined class="custom-button-primary"
                           style="height: 36px;min-width: 42px;padding: 0"
                    >
                        <v-icon color="primary">settings</v-icon>
                    </v-btn>
                </router-link>

                <v-btn outlined class="custom-button-primary"
                       style="height: 36px;min-width: 42px;padding: 0"
                       @click="prepareOpenModal">
                    <v-icon color="primary">edit</v-icon>
                </v-btn>
            </div>
        </div>

        <div class="d-flex ml-2 mr-2 mt-5 flex-wrap">
            <div v-for="tag in currentTags" class="mr-1 ml-1 mt-1 mb-1">
                <v-chip small close @click:close="deleteTag(tag.id)">{{ tag.name }}</v-chip>
            </div>
        </div>

        <v-dialog v-model="openAddTag" persistent max-width="600px">
            <v-card id="edit-tags-card">
                <v-card-title>
                    <span class="headline">Modifier les tags</span>
                </v-card-title>

                <v-card-text>
                    <v-combobox outlined label="Tags" multiple chips small-chips :items="tags" v-model="copyTags"
                                item-text="name" deletable-chips return-object>
                    </v-combobox>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="openAddTag = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="addTags()">
                            Modifier les tags
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "TagBloc",
    props: ["providerId"],
    data() {
        return {
            currentTags: [],
            copyTags: [],
            prepareAddTag: false,
            openAddTag: false,
        }
    },
    methods: {
        deleteTag(tagId) {
            let payload = {
                tagId: tagId,
                providerId: this.providerId,
            }

            this.$http.post("auth/providers/delete-tag", payload).then(res => {
                this.getTags()
            })
        },
        addTags() {
            setTimeout(() => {
                let newTags = []
                let tags = []

                this.copyTags.forEach(tag => {
                    if (typeof tag === "object") {
                        tags.push(tag)
                    } else {
                        newTags.push(tag)
                    }
                })

                let payload = {
                    providerId: this.providerId,
                    tags: tags,
                    newTags: newTags,
                }

                this.$http.post("auth/providers/update-tags", payload).then(res => {
                    this.getTags()

                    this.openAddTag = false
                })
            }, 500)
        },
        prepareOpenModal() {
            this.copyTags = JSON.parse(JSON.stringify(this.currentTags))
            this.openAddTag = true
        },
        getTags() {
            this.$http.get("auth/providers/tags/" + this.providerId).then(res => {
                this.currentTags = res.body.data.tags
            })
        },
    },
    computed: {
        ...mapState("account", ["tags"]),
    },
    created() {
        this.$store.dispatch("account/fetchTags")

        this.getTags()
    },
}
</script>